import React, { Component } from "react";
import Logo from "../../assets/Logo1.png";
export default class Home extends Component {
  render() {
    return (
      <div className='main-box home-box grid'>
        <div class='grid col-12 header'>
          <div style={{ border: "1px solid #fff", padding: "0px 30px" }}>
            <h1 style={{ textAlign: "center", textTransform: "uppercase" }}>{process.env.REACT_APP_ENV} Environment</h1>
          </div>
        </div>

        <div className='col-4'>
          <img src={Logo} className='bigLogo' alt='cargill-logo' />
        </div>
        <div className='col'>
          <h1>Less intuition, more insight.</h1>
          <div className='home-para'>
            <p>
              In the right hands, risk isn't a four-letter word. It's an opportunity to make smarter decisions that can
              yield better results and separate you from the competition.
            </p>
            <p>
              At Cargill, we know where there is risk, there is also an opportunity to be proactive instead of reactive.
            </p>
            <p>
              MiApp provides you with access to valuable information in a powerful new mobile app. As an offering within
              Cargill's Price Risk Solutions portfolio, MiApp is a proprietary mobile application designed to provide
              continuous visibility on global commodity prices that directly impact the cost of your food ingredients as
              well as access to breaking industry news and Cargill's market intelligence.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
